var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnrolled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52596 2.08507L11.7399 5.90684C12.1594 6.08084 12.42 6.47098 12.42 6.925C12.42 7.37902 12.1594 7.76916 11.7399 7.94316L2.52596 11.7649C2.13848 11.9256 1.69986 11.8557 1.38151 11.5802C1.06376 11.3052 0.930887 10.8815 1.03474 10.4744L1.94017 6.925L1.03474 3.37562C0.930887 2.96854 1.06378 2.54484 1.38153 2.26984C1.69928 1.99488 2.13779 1.92405 2.52596 2.08507Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnrolled);
export default __webpack_public_path__ + "static/media/enrolled.8438ff24b19ab70acafb540e4882d341.svg";
export { ForwardRef as ReactComponent };